import React from 'react';
import Modal from 'react-modal';
import Counter from './Counter.jsx';
import WebAPI from '../api/WebAPI.js';
import AuthenticationStore from '../api/AuthenticationStore.js';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: '0px !important',
        background: 'none !important'
    }
};

class SessionTimeOutPopup extends React.Component {

    constructor(props) {
        super(props);
        this.state = { modalIsOpen: true, popupTitle: ((typeof this.props.popupTitle !=='undefined' && this.props.popupTitle !=='' && this.props.popupTitle != null) ? this.props.popupTitle:'Message'), displayType: this.props.displayType, messageContent: this.props.messageContent};

        this.handleAction = this.handleAction.bind(this);	
        this.closeModal = this.closeModal.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
    };

    handleAction(event, name) {
        this.props.popupActionHandler(name);
	}
    closeModal(event) {
        this.setState({ modalIsOpen: false });
        if(typeof this.props.popupActionHandler !== 'undefined'){
            this.props.popupActionHandler('close');
        }
        this.props.closePopup();
        WebAPI.getData('/session/ping').then(response => {
            //do nothing
        }).catch(errRetry => {                                                            
		});
    }

    handleLogout() {
    	this.props.closePopup();
		WebAPI.getData("/session/logout?type=full").then(res => {
            var logoutURL = res.data;
            window.location.href = logoutURL;
        }
        ).catch(err => {window.location.href = window.env.LOGINAPP_URL;})
	}

    componentWillReceiveProps(nextProps) {
        // this.setState({ modalIsOpen: nextProps.modalIsOpen, popupTitle: nextProps.popupTitle });
        if(!this.state.modalIsOpen){
            this.state = {modalIsOpen : true};
        }
    }

    render() {
        let _this=this;
        return (
            <Modal
                isOpen={this.state.modalIsOpen}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.closeModal}
                shouldCloseOnOverlayClick={false}
                contentLabel="Example Modal"
                style={customStyles} ariaHideApp={false} data-target="sessionTimeOutModal" id="myModal" >
                <div className="card card-sub popup-body">
                    <div className="card card-body card-body-body-content card-sub popup-body">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header modal-heading-popup">
                                    <button type="button" className="btn-close close popup-close-btn" onClick={this.closeModal} aria-label="Close"><span className="float-end bi bi-x-circle" onClick={this.closeModal} aria-hidden="true"></span></button>
                                    <span className="modal-title" id="popupModalLabel">{this.state.popupTitle}</span>
                                </div>
                                <div className="modal-body modal-body-popup pre-scrollable" id="popupModal-body">
                                <p className="text-center">For security reasons, you will be automatically logged out in</p>
                                <div>
                                    <div className="countdown-bar active text-center" role="progressbar">
                                        <Counter redirectToLogin={this.handleLogout}/>
                                    </div>
                                </div>
                                <br/>
                                    <div className="card card-body print-area card-button-group">                                                                
                                        <div className="mb-3 float-end">    
                                            <button type="button" className="btn btn-sm btn-primary btn-cancel" onClick={(e) => { _this.handleLogout(e) }} >Logout Now</button>
                                            <button type="button" className="btn btn-sm btn-primary btn-submit" onClick={(e) => { _this.closeModal(e) }} >Stay Logged In</button>
                                        </div>                                                                                        
                                    </div>
                                </div>                                
                                <div className="modal-footer">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }

}

export default SessionTimeOutPopup;